import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./nav-notifications.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./nav-notifications.component.scss?ngResource";
import { Component, ViewEncapsulation } from "@angular/core";
import { NavNotificationConstants } from "./nav-notification.constants";
import { NotifyType } from "./notification.model";
import { SharedConstants } from "../../../shared/constants/shared.constants";
import { ServerNotificationService } from "../../../shared/services/server-notification/server-notification.service";
let NavNotificationsComponent = class NavNotificationsComponent {
    serverNotificationService;
    activityBtnLabel = NavNotificationConstants.ACTIVITY_TEXT;
    warningBtnLabel = NavNotificationConstants.WARNING_TEXT;
    errorBtnLabel = NavNotificationConstants.ERROR_TEXT;
    allBtnLabel = NavNotificationConstants.ALL_TEXT;
    newBtnLabel = NavNotificationConstants.NEW_TEXT;
    noData = SharedConstants.NO_NOTIFICATIONS_AVAILABLE_MESSAGE;
    notificationList = [];
    warning = NotifyType.Warning;
    activity = NotifyType.Activity;
    error = NotifyType.Error;
    countNew = 0;
    openedTab;
    constructor(serverNotificationService) {
        this.serverNotificationService = serverNotificationService;
    }
    ngOnInit() {
        this.notificationList = this.serverNotificationService.getNotificationObservableValue();
        if (this.notificationList)
            this.countNew = this.notificationList.filter(f => !f.isRead).length;
        this.openTab();
    }
    clickOutside() { }
    openTab() {
        this.notificationList = this.serverNotificationService.getNotificationObservableValue();
        if (!this.notificationList)
            return;
        this.markAsRead();
    }
    markAsRead() {
        const notificationListCory = JSON.parse(JSON.stringify(this.notificationList));
        // tslint:disable-next-line: prefer-for-of
        for (let index = 0; index < notificationListCory.length; index++) {
            if (notificationListCory[index].isRead === false) {
                notificationListCory[index].isRead = true;
                --this.countNew;
            }
            this.serverNotificationService.newNotificationObservable(notificationListCory);
        }
    }
    static ctorParameters = () => [
        { type: ServerNotificationService }
    ];
};
NavNotificationsComponent = __decorate([
    Component({
        selector: "app-nav-notifications",
        template: __NG_CLI_RESOURCE__0,
        encapsulation: ViewEncapsulation.None,
        styles: [__NG_CLI_RESOURCE__1]
    })
], NavNotificationsComponent);
export { NavNotificationsComponent };
